import { AccountAccordionList } from '@/features/guided-financial-planning/components/account-accordion-list';

interface AccountDetailsSubstepProps {
  onAllCompleteChange: (allComplete: boolean) => void;
  disabled?: boolean;
}

export function AccountDetailsSubstep({
  onAllCompleteChange,
  disabled,
}: AccountDetailsSubstepProps) {
  return (
    <div className="flex flex-col items-center">
      <AccountAccordionList
        className="w-full max-w-2xl"
        onAllCompleteChange={onAllCompleteChange}
        disabled={disabled}
      />
    </div>
  );
}
